import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from '../../logo.png';

const EventDenied = () => {

  const role = localStorage.getItem('role');
  var homePage = "/";
    switch (role) {
      case 'Visit Requester':
      case 'Requester': homePage = `/AppRequester`; break;
      case 'Admin': homePage = `/AppAdmin`; break;
      case 'Family': homePage = `/AppFamily`; break;
      case 'MLTUser': homePage = `/AppMltEvent`; break;
      case 'FamilyCoordinator': homePage = `/AppFamily`; break;
      case 'MLTCoordinator': homePage = `/AppMltEvent`; break;
    }

    const content = (
        <form id="eventDeniedPage" className="form flex-col">
                <div className="d-flex align-items-center headerButtons">
                    <Link to={homePage} className='navbar-brand mb-0'>
                        <img src={Logo} alt="Logo" width="100" className="d-inline-block align-text-top" />
                    </Link>
                </div>
            <div>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet"
                    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous">
                </link>
                <div className='container-fluid-custom'>
                    <div className="container-fluid">
                       <p></p>
                       <p>Permission denied.</p>
                       <p>This event&apos;s status is currently &quot;Draft&quot;.</p>
                       <p>Draft events are accessible only to their requestor.</p>
                       <Link to={homePage} >Please click here to go to home page.</Link>
                    </div>
                </div>
            </div>
        </form>
    )

    return content
}

export default EventDenied